export enum KitchenSinkRoute {
  kitchenSink = 'Kitchen Sink'
}
